module.exports = __webpack_public_path__ + "static/media/storefront.8cf5b84c.svg";